import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";

const Navbar: React.FC = () => {
    const navigate = useNavigate();
    const { t, language, setLanguage } = useLanguage();

    return (
        <header className="fixed top-0 right-0 left-64 bg-gradient-to-r from-gray-800 via-blue-900 to-indigo-900 shadow-lg z-20">
            <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
                <div className="flex items-center">
                    <nav className="hidden md:flex space-x-6">
                        <a href="/" className="text-white hover:text-blue-200 transition">
                            {t("dashboard")}
                        </a>
                    </nav>
                </div>
                <div className="flex space-x-2">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => setLanguage("en")}
                        className={`py-1 px-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                            language === "en" ? "bg-white text-blue-600" : "bg-blue-500 text-white hover:bg-blue-600"
                        }`}
                    >
                        EN
                    </motion.button>
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => setLanguage("tr")}
                        className={`py-1 px-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                            language === "tr" ? "bg-white text-blue-600" : "bg-blue-500 text-white hover:bg-blue-600"
                        }`}
                    >
                        TR
                    </motion.button>
                </div>
            </div>
        </header>
    );
};

export default Navbar;